import { Route, Switch } from "react-router";
import "./App.css";
import Aboutus from "./components/Pages/Aboutus";
import Contactus from "./components/Pages/Contactus";
import Export from "./components/Pages/Export";
import Media from "./components/Pages/Media";
import Products from "./components/Pages/Products";
import Recipes from "./components/Pages/Recipes";
import Index from "./components/Pages/Index";
import Navbar from "./components/Navbar";

function App() {
  return (
    <>
      <Navbar />
      <Switch>
        <Route path="/aboutus" component={Aboutus} />
        <Route path="/contactus" component={Contactus} />
        <Route path="/exports" component={Export} />
        <Route path="/media" component={Media} />
        <Route path="/products" component={Products} />
        <Route path="/recipes" component={Recipes} />
        <Route strict path="/" component={Index} />
      </Switch>
    </>
  );
}

export default App;
